<template>
  <div>
    <div v-show="needPW">
      <div class="login-field">
        <input
          class="input"
          type="password"
          placeholder="password"
          v-model="password"
          v-on:keyup.enter="CheckPassword"
        />
        <button class="button is-success" v-on:click="CheckPassword">Verify</button>
      </div>
    </div>
    <div v-show="!needPW">
      <header-footer-stats></header-footer-stats>
      <covid-map></covid-map>
    </div>
  </div>
</template>
<script>
import HeaderFooterStats from "../../../components/Statistics/HeaderFooterStats";
import CovidMap from "../../../components/Statistics/CovidMap";

export default {
  components: {
    HeaderFooterStats,
    CovidMap,
  },
  data() {
    return {
      needPW: false,
      password: "",
    };
  },
  mounted() {
    //
  },
  methods:{
    CheckPassword:function(){
      if(process.env.VUE_APP_SHOW_PW == this.password){
        this.needPW = false;
      }
    },
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
</script>
<style lang="scss" scoped>
.login-field {
  position: absolute;
  top: 50%;
  height: 200px;
  width: 20%;
  margin-left: 40%;
}

.button {
  margin-top: 30px;
  width: 20%;
  margin-left: 40%;
}
</style>
